import React, { useState ,useEffect, useRef} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../../Styles/Common.module.css';
import Button from '../../Styles/Button.module.css';
import { Link } from "react-router-dom";
import { FaFilter } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import {getBussinessListFormData,getStateListByCountryId,getCityListByStateId,getCountryListFormData} from '../../../services/routes.services'
import constants from '../../../services/constants'
import PlaceholderImage from '../../../assest/images/no-img.jpg';  // Add a placeholder image
import LoginPopup from "../../Common/Login/UserLogin";
import { useSelector } from 'react-redux';
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";
import { GrFormNextLink, GrFormPreviousLink  } from "react-icons/gr";
const ViewBusinessListingPage= ()=>{

    const [offerPopup, setOfferPopup] = useState(false);
    const [businessData, setBusinessData] = useState([]);
    const [businessDatasix, setBusinessDatasix] = useState([]);
    const [businessPopupData, setBusinessPopupData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    //Select Option
    const [batchOptions, setBatchOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
   
    //Filter
    const [batchFilter, setBatchFilter] = useState('');
    const [categoryFilter, setCategoryFilter] = useState('');
    const [countryFilter, setCountryFilter] = useState('');
    const [stateFilter, setStateFilter] = useState('');
    const [cityFilter, setCityFilter] = useState('');
     // pagination
     const [currentPage, setCurrentPage] = useState(1);
     const [itemsPerPage, setItemsPerPage] = useState(8); // State for items per page
     const [sortOption, setSortOption] = useState('Sort By');
    //Login Popup
    const [loginShow, setLoginShow] = useState(false);
    const { isAuthenticated, user ,token} = useSelector((state) => state.auth);
    const sectionPageingScroll = useRef(null);
    const scrollToSection = (ref) => {
        if (ref && ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("Ref is not attached to a DOM element");
        }
    };
    const loginCloseHandler = ()=>{
            setLoginShow(false)
    }
    useEffect(()=>{
        if(isAuthenticated === false){
            setLoginShow(true)
        }
    }, []);

    useEffect(() => {
        getBussinessListFormData(token)
            .then((res) => {
                const business = res.data.business;
                setBusinessData(business);
                setBusinessDatasix(business);
            //    setBatchOptions([...new Set(business.map(business => business.alumniId).filter(id => id !== undefined))]);
            setBatchOptions([
                ...new Set(business
                    .map(item => item.alumniId?.batch) // Safely extract the batch field
                    .filter(batch => batch !== undefined) // Exclude undefined values
                )
            ].sort((a, b) => a - b)); // Sort numerically
//             const categories = business
//             .map(item => item?.categoryId?.name)
//             .filter(name => name); // remove undefined/null/empty strings

// if (categories.length > 0) {
//   setCategoryOptions([...new Set(categories)]);
// }


const categories = business
  .filter(item => item?.categoryId?.name && item?.categoryId?._id)
  .map(item => ({
    id: item.categoryId._id,
    name: item.categoryId.name
  }));

const uniqueCategories = Array.from(new Map(categories.map(cat => [cat.id, cat])).values());
setCategoryOptions(uniqueCategories);
            // setCategoryOptions([...new Set(business.map(business => business.categoryId.name))]);              
          
            })
            .catch((error) => {
                console.log(error);
            });
            getCountryListFormData()
            .then((res) => {
              const  dataCountry=res.data.countries;
                setCountryOptions(dataCountry);
                // [...new Set(dataCountry.map(country => country.name))]
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);
   
    const lastSixBusiness = businessDatasix.length > 0 ? businessDatasix.slice(-6) : [];
   
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };
    const handleBatchChange = (e) => {
        setBatchFilter(e.target.value);
    };

    const handleCategoryChange = (e) => {
        setCategoryFilter(e.target.value);
    };

    const handleCountryChange = (e) => {
        const selectedCountry = e.target.value;
        setCityOptions([])
         // Fetch states based on selected country
         if(selectedCountry!==''){
            getStateListByCountryId(selectedCountry)
        .then((res) => {
            const dataState=res.data;
            setStateOptions(dataState);
         
           
        })
        .catch((error) => {
            console.log(error);
        });
    }
        setCountryFilter(e.target.value);
    };

    const handleStateChange = (e) => {
        const selectedState = e.target.value;
        if(selectedState!==''){
        // Fetch cities based on selected state
        getCityListByStateId(selectedState)
        .then((res) => {
            const dataCity=res.data;
            setCityOptions(dataCity);
        })
        .catch((error) => {
            console.log(error);
        });
    }
        setStateFilter(e.target.value);
    };

    const handleCityChange = (e) => {
        setCityFilter(e.target.value);
    };

    const filteredAlumni = businessData.filter(businesses => {
        const batchFilterValue = typeof batchFilter === 'number' ? batchFilter : parseInt(batchFilter, 10);

         return (
            (businesses.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            businesses.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
            businesses.email.toLowerCase().includes(searchTerm.toLowerCase())) &&
            (batchFilter === '' || (businesses.alumniId && businesses.alumniId.batch === batchFilterValue)) &&
        
            (categoryFilter === '' || businesses.categoryId?._id === categoryFilter) &&
            // (countryFilter === '' || businesses.country!==''||businesses.country.id === countryFilter) &&
            // (stateFilter === '' ||businesses.state!=""|| businesses.state.id === stateFilter) &&
            // (cityFilter === '' || businesses.city!==''||businesses.city.id === cityFilter) 
            (countryFilter === '' || (businesses.country && businesses.country.id === countryFilter)) &&
(stateFilter === '' || (businesses.state && businesses.state.id === stateFilter)) &&
(cityFilter === '' || (businesses.city && businesses.city.id === cityFilter))
           
        );
    });
   
     
     // Logic to get current items for pagination
     const indexOfLastItem = currentPage * itemsPerPage;
     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
     const currentAlumni = filteredAlumni.slice(indexOfFirstItem, indexOfLastItem);
 
     // Change page
     const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        scrollToSection(sectionPageingScroll);
     }
    const handleResetfilter=()=>{
    
        setBatchFilter('');
        setCategoryFilter('');
        setCountryFilter('');
        setStateFilter('');
        setCityFilter('');
        
      }
    const shoeOfferPopHandler=(Detaildata)=>{
        setOfferPopup(true)
        setBusinessPopupData(Detaildata)
    }
    const closeOfferHandler = ()=>{
        setOfferPopup(false)
    }
   // Handle items per page change
   const handleItemsPerPageChange = (e) => {
     const selectedValue = parseInt(e.target.value, 10);
    setItemsPerPage(selectedValue);
    setCurrentPage(1); // Reset to first page when changing items per page
};
const handleSortChange = (event) => {
    const selectedSortOption = event.target.value;
    setSortOption(selectedSortOption);
    sortBusinessData(selectedSortOption);
};

const sortBusinessData = (option) => {

    let sortedData = [...currentAlumni];
    if (option === 'Latest') {
        sortedData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // Assuming 'date' field exists
    } else if (option === 'Oldest') {
        sortedData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)); // Assuming 'date' field exists
    }
    else if (option === 'Recently Updated') {
        sortedData.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    }
    setBusinessData(sortedData);
};
    return(
        <div className="loginView">
            {isAuthenticated ? 
             <div>
                <section className={Style.clear + " "+Style.breadcrumb}>
                    <Container>
                    <Row>
                        <Col>
                            <ul>
                                <li><Link to="/">Home </Link></li>
                                <li><Link to='/community'>Community</Link></li>
                                <li><Link to='/business-directories'>Business Directory</Link></li>
                                <li>View Business Listing</li>
                            </ul>
                        </Col>
                    </Row>
                    </Container>
                </section>
                <div className={Style.pageTitle + ' ' + Style.marginUp90}>
                    <Container>
                        <Row>
                            <Col>
                                <div className={Style.sectionTitle}>
                                    <h2>Business Directory</h2>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className={Style.pageSubTitle}>
                                    <h3>NEW LISTINGS</h3>
                                    <ul className={Style.newlisting}>
                                    {businessData !==''?(
                                            <>{lastSixBusiness.map((busines)=>{
                                                
                                                return(
                                                <li key={busines._id} onClick={()=>shoeOfferPopHandler(busines)}>
                                                <figure><img src={busines.image ? `${constants.IMAGE_BASE_URL}/business/${busines.image}` : PlaceholderImage} alt={busines.name}/></figure>
                                                <h3>{busines.name}</h3>
                                            <span>{busines.categoryId.name}</span>
                                                </li>
                                                )
                                            })}</>
                                            
                                        ):null}
                                    
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col className={Style.searchArea + ' ' + Style.postffer}>
                                <div className={Style.searchContainer}>
                                    <div className={Style.postButton}>
                                        <Link to='/business-directory-create' className={Button.greenBtn}>Add Your Listing</Link>
                                    </div>
                                    <div className={Style.searchInput}>
                                        <input type="text"   value={searchTerm}  onChange={handleSearchChange}/>
                                        <button type="button">Search</button>
                                    </div>
                                    <div className={Style.byYear}>
                                        <select onChange={handleSortChange} value={sortOption}>
                                            <option value="">Sort By</option>
                                            <option value="Latest">Latest</option>
                                            <option value="Oldest">Oldest</option>
                                            <option value="Recently Updated">Recently Updated</option>
                                        </select>
                                        <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
                                        <option  value="10">Show 10</option>
                                            <option value="20">Show 20</option>
                                            <option value="50">Show 50</option>
                                            <option value="100">Show 100</option>
                                        </select>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className={Style.elementPadding80} ref={sectionPageingScroll}>
                                    <Row>
                                        <Col md={2}>
                                            <div className={Style.FliterSection}>
                                                <div className={Style.filterHead}>
                                                    <h6><FaFilter /> Filter</h6>
                                                    <button type="button" onClick={()=>handleResetfilter()}>Reset</button>
                                                </div>
                                                <div className={Style.filterSelect}>
                                                    <select value={batchFilter} onChange={handleBatchChange}>
                                                        <option value="">Select Batch</option>
                                                        {batchOptions.map(option => (
                                                            <option key={option} value={option}>{option}</option>
                                                        ))}
                                                    </select>
                                                    <select value={categoryFilter} onChange={handleCategoryChange}>
                                                        <option value="">Select Category</option>
                                                        {categoryOptions.map(option => (
                                                            <option key={option.id} value={option.id}>{option.name}</option>
                                                        ))}
                                                    </select>
                                                    <select value={countryFilter} onChange={(e)=>handleCountryChange(e)}>
                                                        <option value="">Select Country</option>
                                                    
                                                        {countryOptions && countryOptions.map(country => (
                                                            <option key={country.id} value={country.id}>{country.name}</option>
                                                        ))}
                                                    </select>
                                                    <select value={stateFilter} onChange={(e)=>handleStateChange(e)}>
                                                        <option value="">Select State</option>
                                                    
                                                        {stateOptions && stateOptions.map(state => (
                                                            <option key={state.id} value={state.id}>{state.name}</option>
                                                        ))}
                                                    </select>
                                                    <select value={cityFilter} onChange={(e)=>handleCityChange(e)}>
                                                        <option value="">Select City</option>
                                                    
                                                        {cityOptions.map(city => (
                                                            <option key={city.id} value={city.id}>{city.name}</option>
                                                        ))}
                                                    </select>
                                                    {/* <button className={Button.greenBtn}>Apply Filter</button> */}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={10}>
                                        {businessData !='' && currentAlumni.length > 0 ?(
                                            <Row>
                                            {currentAlumni.map((businesses) => (
                                            <Col md={6} key={businesses._id}>
                                                <div className={Style.offerElement}>
                                                    <figure>
                                                        <img src={businesses.image ? `${constants.IMAGE_BASE_URL}/business/${businesses.image}` : PlaceholderImage} alt={businesses.name}/>
                                                    </figure>
                                                    <div className={Style.offerDetails}>
                                                        <table>
                                                            <tr>
                                                                <td>Business Name</td>
                                                                <td>{businesses.name}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Category</td>
                                                                <td>{businesses?.categoryId?.name || ''}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>City</td>
                                                            {businesses.city && <td>{businesses.city.name}</td>}
                                                            </tr>
                                                            <tr>
                                                                <td>Alumni Member Name	</td>
                                                                <td>{businesses.username}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Batch</td>
                                                                <td>{businesses.alumniId ?
                                                                        businesses.alumniId.batch
                                                                        : null
                                                                    }</td>
                                                            </tr>
                                                            {/* <tr>
                                                                <td>Offer</td>
                                                                <td><Link to='#' className={Button.greenTextBtn}>View Offer</Link></td>
                                                            </tr> */}
                                                        </table>
                                                    </div>
                                                    <button type="button" onClick={()=>shoeOfferPopHandler(businesses)} className={Button.greenBtn + ' ' + Style.MoreDtl}>More Details</button>
                                                    
                                                </div>
                                            </Col>
                                            ))}
                                                <div>
                                                {offerPopup &&
                                                    <div className={Style.offerPopup}>
                                                        <div className={Style.offerElement}>
                                                            <button onClick={closeOfferHandler} className={Style.closePop}><IoMdClose /></button>
                                                            <figure>
                                                                <img src={businessPopupData.image ? `${constants.IMAGE_BASE_URL}/business/${businessPopupData.image}` : PlaceholderImage}  alt={businessPopupData.name}/>
                                                            </figure>

                                                            <div className={Style.offerDetails}>
                                                                <table role="none">
                                                                
                                                                    <tr>
                                                                        <td>Business Name</td>
                                                                        <td>{businessPopupData?.name}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Category</td>
                                                                        <td>{businessPopupData?.categoryId?.name}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Description</td>
                                                                        <td>{businessPopupData.description}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>City</td>
                                                                        <td>{businessPopupData?.city?.name}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Alumni Member Name	</td>
                                                                        <td>{businessPopupData?.username}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Batch</td>
                                                                        <td>{businessPopupData?.alumniId?.batch}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Designation</td>
                                                                        <td>{businessPopupData?.designation}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Business Contact No.</td>
                                                                        <td><Link to={`tel:${businessPopupData.phone}`}>{businessPopupData?.phone}</Link></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Business Website</td>
                                                                        <td><Link to={businessPopupData.link} target="_blank">{businessPopupData?.link}</Link></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Business Email Id	</td>
                                                                        <td><Link to={`malto:${businessPopupData?.email}`}>{businessPopupData?.email}</Link></td>
                                                                    </tr>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                </div>
                                               
                                            </Row>)
                                            :
                                            (
                                                <Col md={10} className={Style.noDataFound}>
                                                    <p>Data not found.</p>
                                                </Col>
                                            )
                                            }
                                            <Row>
                                                <Col md={12}>
                                                <nav>
                                                <ul className={Button.flextCenterBtn + " " + Style.pagging}>
    {/* Double Left Arrow - Go to First Page */}
    <li className={currentPage === 1 ? Style.disabled : null}>
        <button onClick={() => paginate(1)} className={Style.pageLink} disabled={currentPage === 1}><AiOutlineDoubleLeft className={Style.lastIcon} /></button>
    </li>

    {/* Single Left Arrow - Go to Previous Page */}
    <li className={currentPage === 1 ? Style.disabled : null}>
        <button onClick={() => paginate(currentPage - 1)} className={Style.pageLink} disabled={currentPage === 1}><GrFormPreviousLink  className={Style.lastIcon} /></button>
    </li>

    {/* Page Numbers */}
    {Array.from({ length: Math.ceil(filteredAlumni.length / itemsPerPage) }, (_, index) => index + 1)
        .filter(
            (page) =>
                page === 1 ||
                page === Math.ceil(filteredAlumni.length / itemsPerPage) ||
                (page >= currentPage - 1 && page <= currentPage + 1)
        )
        .map((page, idx, arr) => (
            <React.Fragment key={page}>
                {/* Add an ellipsis for skipped pages */}
                {idx > 0 && arr[idx - 1] !== page - 1 && (
                    <li className={Style.ellipsis}>
                        <span>...</span>
                    </li>
                )}
                <li className={currentPage === page ? Style.active : null}>
                    <button onClick={() => paginate(page)} className={currentPage === page ? Style.activePage : Style.inactivePage}>{page}</button>
                </li>
            </React.Fragment>
        ))}

    {/* Single Right Arrow - Go to Next Page */}
    <li className={
            currentPage === Math.ceil(filteredAlumni.length / itemsPerPage)
                ? Style.disabled
                : null
        }
    >
        <button onClick={() => paginate(currentPage + 1)} className={Style.pageLink} disabled={currentPage === Math.ceil(filteredAlumni.length / itemsPerPage)}>
        <GrFormNextLink className={Style.lastIcon} />
        </button>
    </li>

    {/* Double Right Arrow - Go to Last Page */}
    <li
        className={
            currentPage === Math.ceil(filteredAlumni.length / itemsPerPage)
                ? Style.disabled
                : null
        }
    >
        <button onClick={() =>paginate(Math.ceil(filteredAlumni.length / itemsPerPage))} className={Style.pageLink} disabled={currentPage === Math.ceil(filteredAlumni.length / itemsPerPage)}> <AiOutlineDoubleRight className={Style.lastIcon} /></button>
    </li>
</ul>

                                            </nav>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
            : loginShow && <LoginPopup onClose={loginCloseHandler} /> }
        </div>
    )
}

export default ViewBusinessListingPage;